export const SEARCH_CATEGORIES = {
  ORDER: 'ORDER',
};

export const SEARCH_TYPES = {
  [SEARCH_CATEGORIES.ORDER]: {
    GET_ORDERS: 'GET_ORDERS',
  },
};

export const CUSTOMER_EMAIL_SEARCH_INPUT = 'customerEmail';
